import React, { useContext, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './style.css';
import GlobalHierGrid from '../../components/GlobalHierGrid';
import { ThemeContext } from '../../context/theme.context';
import { TreeGridComponent } from '@syncfusion/ej2-react-treegrid';
import AssetsIntelligenceTabs from './AssetsIntelligenceTabs';
import ImageViewer from './ImageViewer';
const images: Array<any> = [
  {
    url: 'https://s7d2.scene7.com/is/image/Caterpillar/CM20190913-448fc-c416f',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2016/11/21/16/37/loader-1846346_960_720.jpg',
  },
  {
    url: 'https://s7d2.scene7.com/is/image/Caterpillar/CM20201015-79939-53b5e',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2014/08/13/00/28/tipper-417147_960_720.jpg',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2018/01/13/14/20/dump-truck-3080177_960_720.jpg',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2017/08/06/13/53/construction-2592709_960_720.jpg',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2014/08/13/00/31/truck-417149_960_720.jpg',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2019/11/30/22/19/truck-4664409_960_720.jpg',
  },
  {
    url: 'https://cdn.pixabay.com/photo/2018/10/03/17/25/expedition-vehicle-in-arches-3721959_960_720.jpg',
  },
];
var treegridInstance: TreeGridComponent = new TreeGridComponent({});
const AssetsIntelligence = () => {
  const [currentAssetImages, setCurrentAssetImages] = useState<any>([]);
  const [currentApi, setCurrentApi] = useState('asset-hierarchy');
  const [currentAssetCode, setCurrentAssetCode] = useState('');
  const context = useContext(ThemeContext);
  const filterSettings: any = {
    type: 'Menu',
    hierarchyMode: 'Parent',
  };
  const descTemplate = (args: any) => {
    var theBold = 'normal';
    var color = context.isDarkMode ? 'white' : 'black';
    if (args.isParent) {
      theBold = 'bold';
      color = '#22d3ee';
    }
    return (
      <>
        <span style={{ fontWeight: theBold, color: color }}>
          {args.description}
        </span>
      </>
    );
  };
  const toolbar: any = ['ExpandAll', 'CollapseAll', 'Search'];
  const columns = [
    {
      field: 'id',
      headerText: 'ID',
      width: '90',
      textAlign: 'Left',
      visible: false,
      allowFiltering: false,
    },
    {
      field: 'description',
      headerText: 'Description',
      width: '400',
      textAlign: 'Left',
      showCheckbox: true,
      template: descTemplate,
      allowFiltering: true,
    },
    {
      field: 'plant_desc',
      headerText: 'Description',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plant_no',
      headerText: 'Asset No',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plt_type_codes_1',
      headerText: 'Asset Info 1',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plt_type_codes_2',
      headerText: 'Asset Info 2',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plt_type_codes_3',
      headerText: 'Asset Info 3',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plt_type_codes_4',
      headerText: 'Asset Info 4',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plt_serial_no',
      headerText: 'Serial Number',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'asset_parent_code',
      headerText: 'Parent Asset',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'parent_project',
      headerText: 'Parent Project',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'asset_code',
      headerText: 'Asset Number',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      field: 'plt_model',
      headerText: 'Model',
      textAlign: 'Left',
      width: '90',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'plt_supplier',
      headerText: 'Supplier',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'plt_manufacturer',
      headerText: 'Manufacturer',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'plant_type',
      headerText: 'Type',
      textAlign: 'Left',
      allowFiltering: false,
    },

    {
      width: '100',
      field: 'plt_target_mtbf',
      headerText: 'Target MTBF',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'asset_capital_cost',
      headerText: 'Capital Costs',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'mat_total_cost',
      headerText: 'Material Costs',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'total_cost',
      headerText: 'Total Costs',
      textAlign: 'Left',
      allowFiltering: false,
    },

    {
      width: '100',
      field: 'avg_weekly_usage',
      headerText: 'Weekly Avg Usage',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'last_fail_date',
      headerText: 'Last Fail Date',
      textAlign: 'Left',
      format: 'dd/MM/yyyy',
      type: 'date',
      allowFiltering: false,
    },

    {
      width: '100',
      field: 'plt_bom_id',
      headerText: 'Asset BOM Number',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'plt_condition',
      headerText: 'Condition',
      textAlign: 'Left',
      allowFiltering: false,
    },
    {
      width: '100',
      field: 'warranty_date',
      headerText: 'Warranty Date',
      textAlign: 'Left',
      allowFiltering: false,
    },
  ];
  const selectedHandler = (args: any) => {
    if (args.data?.plant_no !== '') {
      setCurrentAssetCode(args.data?.plant_no);
      setCurrentAssetImages([
        images[Math.floor(Math.random() * 9)],
        images[Math.floor(Math.random() * 9)],
      ]);
    }
  };
  return (
    <div className='asset-i-main-content'>
      <div className='contentAsset'>
        <div>
          <GlobalHierGrid
            id='asset-intelligence-grid'
            get_query={currentApi}
            columns={columns}
            filterSettings={filterSettings}
            toolbarOptions={toolbar}
            hasChildMapping='isParent'
            height='40vh'
            idMapping='id'
            parentIdMapping='pid'
            gridHierRef={(ref) => (treegridInstance = ref)}
            width={'70vw'}
            rowSelected={selectedHandler.bind(this)}
            enableTreeSettings={true}
          />
        </div>
        <div className='imagesContent'>
          <ImageViewer currentAssetImages={currentAssetImages} />
        </div>
      </div>
      <div>
        <AssetsIntelligenceTabs asset_code={currentAssetCode} />
      </div>
    </div>
  );
};

export default AssetsIntelligence;
